import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ChatBox from '../chat/ChatBox';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/Chat.css';


export default function ChatDriverCompany() {
  const { t } = useTranslation();  
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const conversationId = state?.conversationId;

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mb-0">✒ {t('chat')}</h4>
        <Button className='add-btn btn btn-primary' onClick={() => navigate('/admin/driver-company-list')}>
          {t('back_to_conversations')}
        </Button>
      </div>
      <ChatBox
        customerId={id}
        conversationId={conversationId}
        title={t('chat_with_driver')}
      />
    </div>
  );
}